var g = function g(t, e) {
    return t.getFullYear() === e.getFullYear() && t.getMonth() === e.getMonth() && t.getDate() === e.getDate();
  },
  r = function r(t, e) {
    return t.getFullYear() === e.getFullYear() && t.getMonth() === e.getMonth();
  };
export { g as isCurrentDay, r as isCurrentMonth };